export default __webpack_public_path__ + "static/media/home-events-conference-img-15.1e475054.jpg";